import Api from '@/services/api';

export default {
  changePwd(change) {
    return Api()
      .put('/changepwd', change)
      .then((res) => res.data);
  },
  changeForgotPwd(change) {
    return Api(false)
      .put('/changeforgotpwd', change)
      .then((res) => res.data);
  },
  changeEmail(change) {
    return Api()
      .put('/changeemail', change)
      .then((res) => res.data);
  },
  resetPwd(mail) {
    return Api(false)
      .post('/resetPwd', {email: mail})
      .then((res) => res.data);
  },
};
